// General actions
export const SET_POS = 'SET_POS'
export const CLEAR_POS = 'CLEAR_POS'
export const SET_DATETIME = 'SET_DATETIME'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const GET_PAYMENT_METHODS = 'GET_PAYMENT_METHODS'
export const LOADING_START = 'LOADING_START'
export const LOADING_END = 'LOADING_END'
export const RECEIVE_PAYMENT_METHODS = 'RECEIVE_PAYMENT_METHODS'
export const RECEIVE_COUNTRIES = 'RECEIVE_COUNTRIES'
export const RECEIVE_CUSTOMERGROUPS = 'RECEIVE_CUSTOMERGROUPS'
export const RECEIVE_LABELS = 'RECEIVE_LABELS'
export const RECEIVE_SYSTEM_SETTING = 'RECEIVE_SYSTEM_SETTING'
export const RECEIVE_USERS = 'RECEIVE_USERS'
export const RECEIVE_DEVICES = 'RECEIVE_DEVICES'
export const SET_LICENSE_STATUS = 'SET_LICENSE_STATUS'
export const SET_HAS_FISCALPRINTER = 'SET_HAS_FISCALPRINTER'
export const DUMMY_CHECK_LICENSE = 'DUMMY_CHECK_LICENSE'
export const RECEIVE_LANGUAGES = 'RECEIVE_LANGUAGES'
export const GET_LICENSES = 'GET_LICENSES'
export const GET_DAYSTILLEXPIRED = 'GET_DAYSTILLEXPIRED'
export const GET_BLACKBOX_STATUS = 'GET_BLACKBOX_STATUS'
export const LIST_CONFIGURATIONS = 'LIST_CONFIGURATIONS'
export const LIST_ARTICLES = 'LIST_ARTICLES'
export const LIST_PRICELIST = 'LIST_PRICELIST'
export const SET_KEYFUNCTION_EXECUTED = 'SET_KEYFUNCTION_EXECUTED'
export const CLEAR_STATE = 'CLEAR_STATE'
export const SET_VERSION = 'SET_VERSION'
export const SET_PAYMENT = 'SET_PAYMENT'
export const SET_UNIQUEID = 'SET_UNIQUEID'
export const SET_BLACKBOX_RECEIPTID = 'SET_BLACKBOX_RECEIPTID'
export const SET_POS_PRICELIST = 'SET_POS_PRICELIST'
export const SET_POS_DEFAULT_PAYMENT = 'SET_POS_DEFAULT_PAYMENT'
export const SET_ROUND_AMOUNT = 'SET_ROUND_AMOUNT'
export const SET_POS_GRAPHIC_DISPLAY = 'SET_POS_GRAPHIC_DISPLAY'
export const SET_BARCODE_PREFIX = 'SET_BARCODE_PREFIX'
export const SET_LOGOUT = 'SET_LOGOUT'
export const ADD_DISCOUNT_MENU_ARTICLEIDS = 'ADD_DISCOUNT_MENU_ARTICLEIDS'

// Modal actions
export const SET_MESSAGE_MODAL = 'SET_MESSAGE_MODAL'
export const SET_SELECT_MODAL = 'SET_SELECT_MODAL'
export const SET_SPLASH_MODAL = 'SET_SPLASH_MODAL'
export const SET_CONFIRM_MODAL = 'SET_CONFIRM_MODAL'
export const SET_CONFIGURATION_MODAL = 'SET_CONFIGURATION_MODAL'
export const SET_SPLIT_RECEIPT_MODAL = 'SET_SPLIT_RECEIPT_MODAL'
export const SPLIT_RECEIPT_MODAL_RECEIPTLINE_SWITCH = "SPLIT_RECEIPT_MODAL_RECEIPTLINE_SWITCH"
export const SET_SEARCH_MODAL = 'SET_SEARCH_MODAL'
export const SET_RECEIPT_MODAL = 'SET_RECEIPT_MODAL'
export const SET_PAYMENT_MODAL = 'SET_PAYMENT_MODAL'
export const SET_ORDER_CONFIRMATION_MODAL = "SET_ORDER_CONFIRMATION_MODAL"
export const SET_PAYMENT_MODAL_CARD_INSERTED = 'SET_PAYMENT_MODAL_CARD_INSERTED'
export const SET_DATEPICKER_MODAL = 'SET_DATEPICKER_MODAL'
export const SET_CUSTOMERBASE_MODAL = 'SET_CUSTOMERBASE_MODAL'
export const SET_CUSTOMEREXISTS_MODAL = 'SET_CUSTOMEREXISTS_MODAL'
export const SET_CONFIGURATIONLIST_MODAL = 'SET_CONFIGURATIONLIST_MODAL'
export const SET_MANAGERLOGIN_MODAL = 'SET_MANAGERLOGIN_MODAL'
export const SET_ORDERLIST_MODAL = 'SET_ORDERLIST_MODAL'
export const SET_SELECT_PAGER_MODAL = 'SET_SELECT_PAGER_MODAL'
export const SET_WEIGH_MODAL_WEIGHT = 'SET_WEIGH_MODAL'
export const SET_WEIGH_MODAL = 'SET_WEIGH_MODAL_WEIGHT'
export const SET_SCALE_STATUS = 'SET_SCALE_STATUS'
export const SET_ARTICLEBASE_MODAL = 'SET_ARTICLEBASE_MODAL'
export const SET_TICKETBASE_MODAL = 'SET_TICKETBASE_MODAL'
export const SET_CHANGE_MODAL = 'SET_CHANGE_MODAL'
export const SET_INPUT_MODAL = 'SET_INPUT_MODAL'
export const SET_CREATE_CUSTOMER_MODAL = 'SET_CREATE_CUSTOMER_MODAL'
export const SET_CREATE_TICKET_MODAL = 'SET_CREATE_TICKET_MODAL'
export const SET_INVOICE_MODAL = 'SET_INVOICE_MODAL'
export const SET_INVOICE_INFO_MODAL = 'SET_INVOICE_INFO_MODAL'
export const SET_RESERVATION_MODAL = 'SET_RESERVATION_MODAL'
export const SET_ADD_BALANCE_TO_TICKET_MODAL = 'SET_ADD_BALANCE_TO_TICKET_MODAL'
export const SET_CASH_REGISTRATION_MODAL = 'SET_CASH_REGISTRATION_MODAL'

// Layout actions
export const SET_LAYOUT = 'SET_LAYOUT'
export const RECEIVE_LAYOUTS = 'RECEIVE_LAYOUTS'
export const SET_FUNCTIONBAR_TYPE = 'SET_FUNCTIONBAR_TYPE'

export const STATUS_FUNCTIONBAR = 'STATUS_FUNCTIONBAR'
export const PRINTER_UPDATE_STATUS = 'PRINTER_UPDATE_STATUS'
export const TOGGLE_KEYBOARD = 'TOGGLE_KEYBOARD'
export const CLEAR_KEYBOARD = 'CLEAR_KEYBOARD'
export const UPDATE_KEYBOARD_INPUT = 'UPDATE_KEYBOARD_INPUT'
export const SET_FOCUSED_FIELD = 'SET_FOCUSED_FIELD'

export const SET_CULTURE = 'SET_CULTURE'
export const SET_RESOURCES = 'SET_RESOURCES'

export const SET_DEFAULT_PAGE = 'SET_DEFAULT_PAGE'
export const SET_CLOSE_PAGE = 'SET_CLOSE_PAGE'

export const SET_PAYMENT_KEY_KEYLAYOUT_GROUP = 'SET_PAYMENT_KEY_KEYLAYOUT_GROUP'

// ObjectGroup actions
export const RECEIVE_OBJECTGROUPLIST = 'RECEIVE_OBJECTGROUPLIST'
export const SET_CURRENT_OBJECTGROUP = 'SET_CURRENT_OBJECTGROUP'
export const OBJECTMANAGEMENT_SET_RECEIPT_NUMBER = 'OBJECTMANAGEMENT_SET_RECEIPT_NUMBER'
export const SET_SELECTED_OBJECTITEM = 'SET_SELECTED_OBJECTITEM'
export const SET_MESSAGEBAR_TEXT = 'SET_MESSAGEBAR_TEXT'

// Receipt actions
export const ADD_QUANTITY = 'ADD_QUANTITY'
export const REMOVE_QUANTITY = 'REMOVE_QUANTITY'
export const REMOVE_RECEIPTLINE = 'REMOVE_RECEIPTLINE'
export const PRINT_RECEIPT = 'PRINT_RECEIPT'
export const COUNTER_INCREMENT = 'COUNTER_INCREMENT'
export const COUNTER_DECREMENT = 'COUNTER_DECREMENT'
export const INPUT_QUANTITY = 'INPUT_QUANTITY'
export const INPUT_QUANTITY_DECIMAL = 'INPUT_QUANTITY_DECIMAL'
export const INPUT_QUANTITY_NEGATIVE = 'INPUT_QUANTITY_NEGATIVE'
export const CANCEL_RECEIPT = 'CANCEL_RECEIPT'
export const REMOVE_LAST_ORDER = 'REMOVE_LAST_ORDER'
export const SET_RECEIPT_NUMBER = 'SET_RECEIPT_NUMBER'
export const FETCH_RECEIPT_NUMBER = 'FETCH_RECEIPT_NUMBER'
export const POST_RECEIPT_START = 'POST_RECEIPT_START'
export const POST_RECEIPT_END = 'POST_RECEIPT_END'
export const EMPTY_RECEIPT = 'EMPTY_RECEIPT'
export const UPDATE_RECEIPTLINES = 'UPDATE_RECEIPTLINES'
export const SET_RECEIPT_OBJECT_ITEM_ID = 'SET_RECEIPT_OBJECT_ITEM_ID'
export const OPEN_RECEIPT = 'OPEN_RECEIPT'
export const REGISTER_CUSTOMER_ACTION = 'REGISTER_CUSTOMER_ACTION'
export const SET_RECEIPT_OBJECT_ITEM_NAME = 'SET_RECEIPT_OBJECT_ITEM_NAME'
export const SET_PRICELIST = 'SET_PRICELIST'
export const SET_PAYMENTDEVICE = 'SET_PAYMENTDEVICE'
export const SET_CUSTOMER = 'SET_CUSTOMER'
export const SET_CARDNAME = 'SET_CARDNAME'
export const SET_TEMPORARY_RIGHTS = 'SET_TEMPORARY_RIGHTS'
export const SET_ARTICLE = 'SET_ARTICLE'
export const SET_RESERVATION_FOR_RECEIPT = 'SET_RESERVATION_FOR_RECEIPT'
export const CLEAR_CUSTOMER = 'CLEAR_CUSTOMER'
export const SET_CANCEL_ON_ABORT = 'SET_CANCEL_ON_ABORT'
export const DISABLE_EDIT_BLACK_BOX_LINES = 'DISABLE_EDIT_BLACK_BOX_LINES'
export const SET_AGE = 'SET_AGE'

export const REPRINT_RECEIPT = 'REPRINT_RECEIPT'
export const SET_PREVIOUS_RECEIPT_ID = 'SET_PREVIOUS_RECEIPT_ID'

export const SET_ORDERNUMBER = 'SET_ORDERNUMBER'

export const SET_PAGERNUMBER = 'SET_PAGERNUMBER'

export const SET_SHOULD_INVOICE = 'SET_SHOULD_INVOICE'
export const SET_INVOICE_REFERENCE = 'SET_INVOICE_REFERENCE'
export const EINVOICE_ACTIVE = 'EINVOICE_ACTIVE'

// Login actions
export const RECEIVE_POSLIST = 'RECEIVE_POSLIST'
export const RECEIVE_STORELIST = 'RECEIVE_STORELIST'
export const RECEIVE_COMPANYLIST = 'RECEIVE_COMPANYLIST'

export const SET_TEMP_DEFAULT_CHANGE_ID = 'SET_TEMP_DEFAULT_CHANGE_ID'



// WEBPACK FOOTER //
// src/constants/ActionTypes.js